<template>
  <div class="addFromAdmin">
    <table-list
      :loading="loading"
      :title="$route.meta.title"
      :data="adminList"
      :search-form="searchForm(this)"
      :columns="columns(this)"
      :btns="btns(this)"
      :options="{ selection: true }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
    ></table-list>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '确定选择',
    method: _this.handleSave,
    type: 'primary',
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    label: '姓名/手机号/身份证',
    prop: 'userFilter',
  },
  {
    label: '请选择角色',
    type: 'select',
    prop: 'roleName',
    children: _this.roleList.map(item => ({
      value: item.roleName,
      label: item.roleName,
    })),
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'userName',
    label: '姓名',
    minWidth: 120,
  },
  {
    prop: 'phone',
    label: '手机号码',
    minWidth: 120,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 170,
  },
  {
    prop: 'role',
    label: '管理员角色',
    minWidth: 200,
  },
  {
    prop: 'createTime',
    label: '添加时间',
    minWidth: 150,
    sortdata: 1,
  },
]
import TableList from '@/components/TableList'
import { userRoleList, roleList, proctorAdd } from '@/api/system'
import to from 'await-to'
export default {
  name: 'AddFromAdmin',
  components: {
    TableList,
  },
  data() {
    return {
      columns,
      searchForm,
      loading: false,
      btns,
      adminList: [],
      select: [],
      queryParams: {},
      roleList: [],
      clientCode: '52817232-63e9-11ed-a8c9-506b4b42',
    }
  },
  mounted() {
    this.getRoleList()
    this.getAdminListData()
  },
  methods: {
    async getAdminListData() {
      if (this.loading) return
      this.loading = true
      const [res, err] = await to(userRoleList({ ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.adminList = res.data
    },
    async getRoleList() {
      const [res, err] = await to(roleList({ clientCode: this.clientCode }))
      if (err) return this.$message.warning(err.msg)
      this.roleList = res.data
    },
    handleSelectionChange(val) {
      this.select = val
    },
    onSearch(queryParams) {
      this.queryParams = queryParams
      this.getAdminListData()
    },
    async handleSave() {
      const [, err] = await to(proctorAdd({ userIds: this.select.map(item => item.id) }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
      this.$router.push('/system/proctor')
    },
  },
}
</script>
